import type { DataChartStyleProps } from './datachartStyleRegistry'
import { EnergyChartBase } from './EnergyChartBase'

export function EnergyChartStyle01(props: DataChartStyleProps) {
  return <EnergyChartBase variant="blue" chartType="area" {...props} />
}
